import PropTypes from 'prop-types';
import Modal from 'react-bootstrap/Modal';
import { useSelector } from 'react-redux';
import sprite from 'src/assets/sprite.svg';
import { useTranslation } from 'src/hooks';

const DeleteResume = ({ handleDeleteCover, show, handleClose }) => {
  const fixWaiter = useSelector((state) => state.templatesReducer.fixWaiter);

  const { translate } = useTranslation();
  return (
    <Modal show={show} onHide={handleClose} fullscreen="sm-down">
      <Modal.Header>
        <div />
        <button className="modal-closeBtn" type="button" onClick={handleClose}>
          <svg id="close" width="24" height="24" viewBox="0 0 24 24">
            <use xlinkHref={`${sprite}#close`} />
          </svg>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="deleteResume">
          <div className="modal__title">{translate('components.delete_cover_letter')}</div>
          <div className="modal__text">{translate('components.delete_cover_letter_desc')}</div>
          <div className="deleteResume__btns">
            <button type="button" className="btn btn-outline-primary" onClick={handleDeleteCover}>
              {fixWaiter ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  />
                  <span className="sr-only">{translate('loading')}</span>
                </>
              ) : (
                <>Delete</>
              )}
            </button>
            <button type="button" className="btn btn-primary" onClick={handleClose}>
              Cancel
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

DeleteResume.propTypes = {
  handleDeleteCover: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
};

export default DeleteResume;
